import { Record } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { Models_AdmittanceUser, Models_AdmittanceAndFenixUser, Models_AdmittanceUserDto, Models_AdmittanceAndFenixUser$reflection } from "../../ApiClient/WebApi.js";
import { getTranslationFrom, GlobalDependencies$reflection, LoadState$2, SaveStatus, SaveStatus$reflection } from "../../Global.js";
import { lambda_type, unit_type, list_type, string_type, class_type, int32_type, record_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { parseInt64, parseDateTime, DateTimeExtensions_toDateHHmm, truncateWithEllipsis, logei, delayAsync, Locale_get_FromSelectedLanguage, stackClasses, classNames } from "../../Utils.js";
import { sortBy, sortByDescending, fold, empty, contains, filter, singleton, map, ofArray } from "../../fable_modules/fable-library.3.7.20/List.js";
import * as react from "react";
import { DOMAttr, HTMLAttr } from "../../fable_modules/Fable.React.7.4.3/Fable.React.Props.fs.js";
import { keyValueList } from "../../fable_modules/fable-library.3.7.20/MapUtil.js";
import { FunctionComponent_Of_Z5A158BBF } from "../../fable_modules/Fable.React.7.4.3/Fable.React.FunctionComponent.fs.js";
import { startImmediate } from "../../fable_modules/fable-library.3.7.20/Async.js";
import { singleton as singleton_1 } from "../../fable_modules/fable-library.3.7.20/AsyncBuilder.js";
import { saveIpWhiteList as saveIpWhiteList_1, saveMfa, loadImpersonateUser as loadImpersonateUser_1, loadAdmittanceUsersFromFenix, loadAdmittanceUsers as loadAdmittanceUsers_1, loadUserPrincipalPrivileges } from "./Api.js";
import { compare, split, replace, printf, toText } from "../../fable_modules/fable-library.3.7.20/String.js";
import { List_groupBy } from "../../fable_modules/fable-library.3.7.20/Seq2.js";
import { comparePrimitives, equals, stringHash, uncurry, arrayHash, equalArrays } from "../../fable_modules/fable-library.3.7.20/Util.js";
import { getMaterialIcon, Size, getMaterialIconBySize, renderAnimationCheckmark, getWrappedMaterialIcon, MaterialIcon_render_6162D7CC, dotsLoading } from "../../ViewUtils.js";
import { MessageKind, customMessage, error } from "../../Components/Message/Message.js";
import { bind, map as map_1, defaultArg } from "../../fable_modules/fable-library.3.7.20/Option.js";
import { equalsWith } from "../../fable_modules/fable-library.3.7.20/Array.js";
import { create, match } from "../../fable_modules/fable-library.3.7.20/RegExp.js";
import { render as render_1 } from "../../Components/Modals/Standard.js";
import { ModalSize } from "../../Components/Modal/Modal.js";
import { Browser_Types_Event__Event_get_Value } from "../../fable_modules/Fable.React.7.4.3/Fable.React.Extensions.fs.js";
import { toString } from "../../fable_modules/fable-library.3.7.20/Date.js";
import { useDispatch, useSelector } from "../../Redux/Store.js";
import { toList as toList_1, FSharpMap__get_Item, add, tryFind, FSharpMap__Add, empty as empty_1 } from "../../fable_modules/fable-library.3.7.20/Map.js";
import { Result_Map } from "../../fable_modules/fable-library.3.7.20/Choice.js";
import { render as render_2 } from "../../Components/Modals/SaveState/SaveState.js";
import { CustomContentAreaTableProps, Elements_renderCell, Elements_renderHeader, renderHeader, renderCustomContentAreaTable } from "../../Components/Table/Table.js";
import { empty as empty_2, singleton as singleton_2, append, delay, toList } from "../../fable_modules/fable-library.3.7.20/Seq.js";
import { SelectOption, ValueProp, SelectOption_get_getDefault, selectOption } from "../../Components/FormFields/FormFields.js";
import { error as error_1 } from "../../Redux/Reducers/ModalsReducer.js";
import { toString as toString_1 } from "../../fable_modules/fable-library.3.7.20/Long.js";
import { TabContainerProps, TabContainerProps_get_Default, renderTabContainer, Tab } from "../../Components/TabContainer/TabContainer.js";
import "../../../src/Containers/AdmittanceUsers/View.scss";


export class AdmittanceUserDTOGui extends Record {
    constructor(Data, SaveState) {
        super();
        this.Data = Data;
        this.SaveState = SaveState;
    }
}

export function AdmittanceUserDTOGui$reflection() {
    return record_type("Containers.AdmittanceUsers.View.AdmittanceUserDTOGui", [], AdmittanceUserDTOGui, () => [["Data", Models_AdmittanceAndFenixUser$reflection()], ["SaveState", SaveStatus$reflection()]]);
}

export function AdmittanceUserDTOGuiModule_ofDto(dto) {
    return new AdmittanceUserDTOGui(dto, new SaveStatus(0));
}

function renderAggregateResource(isGroupPrivilege, aggregateResource) {
    const classes = classNames(ofArray([["badge", true], ["admittance-user__badge", true], ["badge-success", isGroupPrivilege], ["badge-primary", !isGroupPrivilege], ["d-flex", true], ["align-items-center", true]]));
    return react.createElement("div", {
        className: classes,
    }, aggregateResource);
}

function renderRole(_arg1_, _arg1__1) {
    let children_4;
    const _arg = [_arg1_, _arg1__1];
    const aggregateResourceHtml = map((dto) => renderAggregateResource(dto.GroupPrincipalId != null, dto.AggregatedResource), _arg[1]);
    const props_8 = [new HTMLAttr(65, stackClasses(singleton("d-flex")))];
    const children_8 = [(children_4 = [react.createElement("h5", {}, _arg[0][0]), react.createElement("div", {
        className: "privileges__grey",
    }, _arg[0][1])], react.createElement("div", {
        className: "mr-4",
    }, ...children_4)), react.createElement("div", {
        className: "admittance-user__container",
    }, ...aggregateResourceHtml)];
    return react.createElement("div", keyValueList(props_8, 1), ...children_8);
}

function renderPrivileges(privileges) {
    const children = map((tupledArg) => renderRole(tupledArg[0], tupledArg[1]), privileges);
    return react.createElement("div", {
        className: "admittance-user__privileges",
    }, ...children);
}

class ExpandAreaProps extends Record {
    constructor(ClientNr, PrincipalId, DTO) {
        super();
        this.ClientNr = (ClientNr | 0);
        this.PrincipalId = PrincipalId;
        this.DTO = DTO;
    }
}

function ExpandAreaProps$reflection() {
    return record_type("Containers.AdmittanceUsers.View.ExpandAreaProps", [], ExpandAreaProps, () => [["ClientNr", int32_type], ["PrincipalId", class_type("System.Int64")], ["DTO", AdmittanceUserDTOGui$reflection()]]);
}

const renderExpandAreaFromDTO = FunctionComponent_Of_Z5A158BBF((props) => {
    let children_11, children_9, children_29, children_25, children_17, children_23, props_20, props_22;
    const privilegesLoadState = react.useState(new LoadState$2(0));
    react.useEffect(() => {
        privilegesLoadState[1](new LoadState$2(1));
        startImmediate(singleton_1.Delay(() => singleton_1.Bind(loadUserPrincipalPrivileges(props.PrincipalId), (_arg) => {
            const result = _arg;
            let arg_2;
            if (result.tag === 0) {
                const aggregatedRole = toText(printf("XFenix.C%i"))(props.ClientNr);
                arg_2 = (new LoadState$2(2, List_groupBy((dto_1) => [dto_1.RoleName, dto_1.AggregatedRole], filter((dto) => {
                    if (dto.AggregatedRole === "XFenix") {
                        return true;
                    }
                    else {
                        return dto.AggregatedRole.indexOf(aggregatedRole) === 0;
                    }
                }, result.fields[0]), {
                    Equals: equalArrays,
                    GetHashCode: arrayHash,
                })));
            }
            else {
                arg_2 = (new LoadState$2(3, result.fields[0]));
            }
            privilegesLoadState[1](arg_2);
            return singleton_1.Zero();
        })));
    }, [props.DTO.Data.AdmittanceUser.PrincipalId]);
    let privilegesHtml;
    const matchValue = privilegesLoadState[0];
    switch (matchValue.tag) {
        case 1: {
            privilegesHtml = dotsLoading;
            break;
        }
        case 3: {
            privilegesHtml = error(matchValue.fields[0].split(""));
            break;
        }
        case 2: {
            privilegesHtml = renderPrivileges(matchValue.fields[0]);
            break;
        }
        default: {
            privilegesHtml = react.createElement(react.Fragment, {});
        }
    }
    const renderUserDetail = (label, content) => {
        const children_5 = [react.createElement("div", {
            className: "admittance-user__user-detail-label",
        }, label), react.createElement("div", {
            className: "admittance-user__user-detail-value",
        }, content)];
        return react.createElement("div", {
            className: "admittance-user__user-detail",
        }, ...children_5);
    };
    const children_31 = [(children_11 = [react.createElement("div", {
        className: "admittance-user__section-title",
    }, "Kontouppgifter"), (children_9 = [renderUserDetail("E-post", props.DTO.Data.AdmittanceUser.Email), renderUserDetail("Mobilnummer", defaultArg(props.DTO.Data.AdmittanceUser.MobileNo, "-")), renderUserDetail("Skapad", defaultArg(props.DTO.Data.AdmittanceUser.CreatedTime, "-"))], react.createElement("div", {
        className: "admittance-user__container",
    }, ...children_9))], react.createElement("div", {
        className: "admittance-user__details-section",
    }, ...children_11)), (children_29 = [(children_25 = [(children_17 = [react.createElement("div", {
        className: "admittance-user__section-title",
    }, "Rättigheter"), react.createElement("div", {
        className: "admittance-user__section-description",
    }, "Rättigheter som är kopplade till användarens grupper eller direkt till kontot.")], react.createElement("div", {}, ...children_17)), (children_23 = [(props_20 = [new HTMLAttr(158, "Rättighet som är kopplad till kontots grupptillhörighet"), new HTMLAttr(65, stackClasses(ofArray(["badge", "badge-success", "admittance-user__badge"])))], react.createElement("span", keyValueList(props_20, 1), "Grupprättighet")), (props_22 = [new HTMLAttr(158, "Rättighet som tillhör detta konto"), new HTMLAttr(65, stackClasses(ofArray(["badge", "badge-primary", "ml-2", "admittance-user__badge"])))], react.createElement("span", keyValueList(props_22, 1), "Användarrättighet"))], react.createElement("div", {
        className: "admittance-user__legend",
    }, ...children_23))], react.createElement("div", {
        className: "admittance-user__privileges-header",
    }, ...children_25)), react.createElement("div", {
        className: "admittance-user__privileges-content",
    }, privilegesHtml)], react.createElement("div", {
        className: "admittance-user__privileges-section",
    }, ...children_29))];
    return react.createElement("div", {
        className: "admittance-user__expand-area",
    }, ...children_31);
}, "AdmittanceUserExpandArea", uncurry(2, void 0), void 0, "renderExpandAreaFromDTO", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\AdmittanceUsers\\View.fs", 141);

class IpWhiteListModalProps extends Record {
    constructor(IpWhiteList, OnSaveFn, OnCloseFn) {
        super();
        this.IpWhiteList = IpWhiteList;
        this.OnSaveFn = OnSaveFn;
        this.OnCloseFn = OnCloseFn;
    }
}

function IpWhiteListModalProps$reflection() {
    return record_type("Containers.AdmittanceUsers.View.IpWhiteListModalProps", [], IpWhiteListModalProps, () => [["IpWhiteList", string_type], ["OnSaveFn", lambda_type(list_type(string_type), unit_type)], ["OnCloseFn", lambda_type(unit_type, unit_type)]]);
}

const renderIpWhiteListModal = FunctionComponent_Of_Z5A158BBF((props) => {
    let children_5, props_4;
    const textAreaState = react.useState(replace(props.IpWhiteList, ";", "\n"));
    const showErrorMessageState = react.useState(false);
    const isValidInput = (input) => {
        let array;
        const matchValue = split(input, ["\n"], null, 0);
        let pattern_matching_result, splitted;
        if ((!equalsWith((x, y) => (x === y), matchValue, null)) && (matchValue.length === 1)) {
            if (matchValue[0] === "") {
                pattern_matching_result = 0;
            }
            else {
                pattern_matching_result = 1;
                splitted = matchValue;
            }
        }
        else {
            pattern_matching_result = 1;
            splitted = matchValue;
        }
        switch (pattern_matching_result) {
            case 0: {
                array = [];
                break;
            }
            case 1: {
                array = splitted;
                break;
            }
        }
        return array.every((row) => {
            let tupledArg;
            return ((tupledArg = [row, "^(25[0-5]|2[0-4]\\d|1?\\d?\\d)(\\.(25[0-5]|2[0-4]\\d|1?\\d?\\d)){3}(\\/([0-9]|[12][0-9]|3[0-2]))?$"], match(create(tupledArg[1]), tupledArg[0]))) != null;
        });
    };
    const infoHtml = customMessage(react.createElement("div", {
        className: "ip-whitelist__info",
    }, "Lägg in en eller flera ip-adresser per rad, med eller utan subnät (utan delimiters). Ex:\n127.0.0.1\n127.0.0.2/26\n127.0.0.3"), new MessageKind(0));
    const validationMessageHtml = (showErrorMessageState[0]) ? error("Incorrect format of ip-addresses".split("")) : react.createElement(react.Fragment, {});
    return render_1(true, new ModalSize(1), "IP Whitelist", (children_5 = [infoHtml, (props_4 = [new HTMLAttr(136, 10), new HTMLAttr(66, 1), new DOMAttr(9, (e) => {
        const arg_2 = Browser_Types_Event__Event_get_Value(e);
        textAreaState[1](arg_2);
    }), new HTMLAttr(161, textAreaState[0]), new HTMLAttr(128, "Example: 127.0.0.1"), new DOMAttr(7, (_arg) => {
        showErrorMessageState[1](false);
    }), new DOMAttr(8, (_arg_1) => {
        if (isValidInput(textAreaState[0])) {
            showErrorMessageState[1](false);
        }
        else {
            showErrorMessageState[1](true);
        }
    })], react.createElement("textarea", keyValueList(props_4, 1))), validationMessageHtml], react.createElement("div", {
        className: "admittance-user__ip-whitelist",
        id: "admittance-user-whitelist-textarea",
    }, ...children_5)), "Avbryt", "Spara", (_arg_2) => {
        props.OnCloseFn();
    }, (_arg_3) => {
        let _arg_4;
        if (isValidInput(textAreaState[0])) {
            props.OnSaveFn(ofArray((_arg_4 = split(textAreaState[0], ["\n"], null, 0), ((!equalsWith((x_1, y_1) => (x_1 === y_1), _arg_4, null)) && (_arg_4.length === 1)) ? ((_arg_4[0] === "") ? [] : _arg_4) : _arg_4)));
            props.OnCloseFn();
        }
    });
}, "IpWhiteListModal", uncurry(2, void 0), void 0, "renderIpWhiteListModal", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\AdmittanceUsers\\View.fs", 225);

export class AdmittanceUsersProps extends Record {
    constructor(GlobalDependencies) {
        super();
        this.GlobalDependencies = GlobalDependencies;
    }
}

export function AdmittanceUsersProps$reflection() {
    return record_type("Containers.AdmittanceUsers.View.AdmittanceUsersProps", [], AdmittanceUsersProps, () => [["GlobalDependencies", GlobalDependencies$reflection()]]);
}

function isSveaUser(dto) {
    const accountType = dto.Data.AdmittanceUser.AccountType.trim();
    const username = dto.Data.FenixUser.Username.trim().toLowerCase();
    if (compare(accountType, "Active Directory", 5) === 0) {
        return true;
    }
    else {
        return contains(username, ofArray(["fenixsystem", "status", "svenskKraftcreditcheck"]), {
            Equals: (x, y) => (x === y),
            GetHashCode: stringHash,
        });
    }
}

function toAdmittanceAndFenixUser(user) {
    return new Models_AdmittanceAndFenixUser(new Models_AdmittanceUserDto(defaultArg(user.AccountType, ""), map_1((date) => toString(date, "O"), user.CreatedDateSwedish), user.Email, map_1((date_1) => toString(date_1, "O"), user.LastLoginSwedish), user.Username, user.MobileNo, user.Name, user.UserId, empty()), {
        AdmittanceLoginEnabled: user.AdmittanceLoginEnabled,
        Email: user.Email,
        IpWhiteList: user.IpWhiteList,
        IsApi: user.IsApi,
        MfaMethod: user.MfaMethod,
        Name: user.Name,
        RequireIdsStepUp: user.RequireIdsStepUp,
        UserId: user.UserId,
        Username: user.Username,
    });
}

export const renderAdmittanceUsers = FunctionComponent_Of_Z5A158BBF((props) => {
    let contentHtml_1, principalId_2;
    const locale = Locale_get_FromSelectedLanguage()(props.GlobalDependencies.SelectedLanguage);
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const reduxDispatch = useDispatch();
    const activeRowIdState = react.useState(void 0);
    const admittanceUsersLoadState = react.useState(new LoadState$2(0));
    const admittanceUsersState = react.useState(empty_1());
    const impersonateLoadState = react.useState(new LoadState$2(0));
    const ipWhiteListModalState = react.useState(void 0);
    const loadAdmittanceUsers = () => {
        if ((admittanceUsersLoadState[0]).tag === 2) {
        }
        else {
            admittanceUsersLoadState[1](new LoadState$2(1));
        }
        startImmediate(singleton_1.Delay(() => singleton_1.Bind(props.GlobalDependencies.IsAdminUser ? loadAdmittanceUsers_1(props.GlobalDependencies.ClientNr) : singleton_1.Delay(() => singleton_1.Bind(loadAdmittanceUsersFromFenix(props.GlobalDependencies.ClientNr), (_arg) => singleton_1.Return(Result_Map((list) => map(toAdmittanceAndFenixUser, list), _arg)))), (_arg_1) => {
            const result_1 = _arg_1;
            let arg_2;
            if (result_1.tag === 0) {
                const arg = fold((acc, dto) => FSharpMap__Add(acc, dto.AdmittanceUser.PrincipalId, AdmittanceUserDTOGuiModule_ofDto(dto)), empty_1(), result_1.fields[0]);
                admittanceUsersState[1](arg);
                arg_2 = (new LoadState$2(2, void 0));
            }
            else {
                arg_2 = (new LoadState$2(3, result_1.fields[0]));
            }
            admittanceUsersLoadState[1](arg_2);
            return singleton_1.Zero();
        })));
    };
    react.useEffect(() => {
        loadAdmittanceUsers();
    }, [props.GlobalDependencies.ClientNr]);
    let impersonateModalHtml;
    const renderModal = (saveItems) => render_2(true, new ModalSize(0), "Impersonate", saveItems, "Ok", (_arg_5) => {
        impersonateLoadState[1](new LoadState$2(0));
    });
    const matchValue_3 = impersonateLoadState[0];
    switch (matchValue_3.tag) {
        case 1: {
            impersonateModalHtml = renderModal(singleton(["Impersonating...", new SaveStatus(1)]));
            break;
        }
        case 3: {
            impersonateModalHtml = renderModal(singleton(["Impersonating...", new SaveStatus(3, matchValue_3.fields[0])]));
            break;
        }
        case 2: {
            impersonateModalHtml = renderModal(singleton(["Impersonating...", new SaveStatus(2)]));
            break;
        }
        default: {
            impersonateModalHtml = react.createElement(react.Fragment, {});
        }
    }
    const renderTable = (users) => {
        let hdr;
        const matchValue_5 = admittanceUsersLoadState[0];
        switch (matchValue_5.tag) {
            case 1: {
                return dotsLoading;
            }
            case 3: {
                return error(matchValue_5.fields[0].split(""));
            }
            case 2: {
                let loginHelp;
                const x_16 = map((tupledArg_1) => {
                    const children_20 = [react.createElement("div", {
                        className: "font-weight-bold",
                    }, tupledArg_1[0]), react.createElement("div", {}, tupledArg_1[1])];
                    return react.createElement("p", {
                        className: "font-weight-light",
                    }, ...children_20);
                }, ofArray([["Admittance", "Användarnamn och lösenord. Sveas gammla sätt att logga in med, håller på att fasas ut."], ["Stepup", "Kräver att man registrerar sig med BankId vid nästa inloggning. Efter det så byts inloggningen till IDS"], ["OTP", "One time password - ett mail skickas med en kod vid inloggning med användarnamn och lösenord, som krävs för att kunna logga in"], ["IDS", "Sveas nya sätt att logga in. Idag synonymt med BankId, men fler inloggningssätt kommer komma över tid (Entra, Authenticator osv)"], ["Admittance (Api)", "API-baserad inloggning som används när en integration eller tjänst behöver autentisera en användare via Admittance."]]));
                loginHelp = react.createElement("div", {}, ...x_16);
                return renderCustomContentAreaTable(new CustomContentAreaTableProps((hdr = (renderHeader), toList(delay(() => append(singleton_2(hdr("")), delay(() => append(singleton_2(hdr("Id")), delay(() => append(singleton_2(hdr("Name")), delay(() => append(singleton_2(hdr("Inloggningsnamn")), delay(() => append(singleton_2(hdr("Type")), delay(() => {
                    let children_24;
                    return append(singleton_2(Elements_renderHeader((children_24 = ["Login", MaterialIcon_render_6162D7CC("help", loginHelp)], react.createElement("div", {
                        className: "d-flex",
                    }, ...children_24)))), delay(() => append(singleton_2(hdr("IP Skydd")), delay(() => append(singleton_2(hdr("Senast inloggad")), delay(() => (props.GlobalDependencies.IsAdminUser ? append(singleton_2(hdr("Actions")), delay(() => singleton_2(hdr("")))) : empty_2())))))));
                }))))))))))))), map((dto_1) => {
                    let inputRecord_4, Id, Disabled, OptionValues, tupledArg, fenixUser, matchValue_6;
                    let impersonateHtml;
                    const children_4 = [getWrappedMaterialIcon("person_search"), "Impersonate"];
                    impersonateHtml = react.createElement("div", {
                        onClick: (e) => {
                            impersonateLoadState[1](new LoadState$2(1));
                            startImmediate(singleton_1.Delay(() => singleton_1.Bind(loadImpersonateUser_1(dto_1.Data.AdmittanceUser.PrincipalId), (_arg_2) => {
                                const result_2 = _arg_2;
                                let arg_4;
                                if (result_2.tag === 1) {
                                    arg_4 = (new LoadState$2(3, result_2.fields[0]));
                                }
                                else {
                                    window.location.href = "/";
                                    arg_4 = (new LoadState$2(2, ""));
                                }
                                impersonateLoadState[1](arg_4);
                                return singleton_1.Zero();
                            })));
                            e.stopPropagation();
                        },
                        className: "admittance-user__impersonate",
                    }, ...children_4);
                    let mfaSelectHtml;
                    const admittance = "Admittance";
                    const admittanceStepUp = "Admittance (Stepup)";
                    const admittanceOtp = "Admittance (OTP)";
                    const admittanceOtpStepUp = "Admittance (OTP \u0026 Stepup)";
                    const ids = "IDS";
                    const isApi = "Admittance (Api)";
                    const children_6 = [selectOption((inputRecord_4 = SelectOption_get_getDefault(), (Id = toText(printf("admittance-user-mfa-select-%i"))(dto_1.Data.AdmittanceUser.PrincipalId), (Disabled = (((!props.GlobalDependencies.IsAdminUser) ? true : equals(dto_1.SaveState, new SaveStatus(2))) ? true : equals(dto_1.SaveState, new SaveStatus(1))), (OptionValues = map((x_5) => [x_5, x_5], ofArray([admittance, admittanceStepUp, admittanceOtp, admittanceOtpStepUp, ids, isApi])), new SelectOption((tupledArg = ((fenixUser = dto_1.Data.FenixUser, [(matchValue_6 = [fenixUser.MfaMethod, fenixUser.AdmittanceLoginEnabled, fenixUser.RequireIdsStepUp, fenixUser.IsApi], (matchValue_6[0] != null) ? (matchValue_6[1] ? ((matchValue_6[0] === "otp") ? (matchValue_6[2] ? admittanceOtpStepUp : admittanceOtp) : (matchValue_6[2] ? admittanceStepUp : admittance)) : ids) : (matchValue_6[1] ? (matchValue_6[2] ? admittanceStepUp : (matchValue_6[3] ? isApi : admittance)) : ids)), (e_2) => {
                        let matchValue_1, admittanceUser, updatedAdmittanceUser, inputRecord, value;
                        let body;
                        const matchValue_7 = Browser_Types_Event__Event_get_Value(e_2);
                        switch (matchValue_7) {
                            case admittance: {
                                body = (new Models_AdmittanceUser(true, false, false, false));
                                break;
                            }
                            case admittanceStepUp: {
                                body = (new Models_AdmittanceUser(true, false, false, true));
                                break;
                            }
                            case admittanceOtp: {
                                body = (new Models_AdmittanceUser(true, false, true, false));
                                break;
                            }
                            case admittanceOtpStepUp: {
                                body = (new Models_AdmittanceUser(true, false, true, true));
                                break;
                            }
                            case isApi: {
                                body = (new Models_AdmittanceUser(true, true, false, false));
                                break;
                            }
                            default: {
                                body = (new Models_AdmittanceUser(false, false, true, true));
                            }
                        }
                        const principalId_1 = dto_1.Data.AdmittanceUser.PrincipalId;
                        startImmediate((matchValue_1 = tryFind(principalId_1, admittanceUsersState[0]), (matchValue_1 != null) ? ((admittanceUser = matchValue_1, (updatedAdmittanceUser = (new AdmittanceUserDTOGui(new Models_AdmittanceAndFenixUser(admittanceUser.Data.AdmittanceUser, (inputRecord = admittanceUser.Data.FenixUser, {
                            AdmittanceLoginEnabled: body.AdmittanceEnabled,
                            Email: inputRecord.Email,
                            IpWhiteList: inputRecord.IpWhiteList,
                            IsApi: body.IsApi,
                            MfaMethod: body.Otp ? "otp" : (void 0),
                            Name: inputRecord.Name,
                            RequireIdsStepUp: body.RequireStepUp,
                            UserId: inputRecord.UserId,
                            Username: inputRecord.Username,
                        })), admittanceUser.SaveState)), (admittanceUsersState[1]((value = (new AdmittanceUserDTOGui(updatedAdmittanceUser.Data, new SaveStatus(1))), (table_1) => add(principalId_1, value, table_1))), singleton_1.Delay(() => singleton_1.Bind(saveMfa(principalId_1, body), (_arg_3) => {
                            let value_2, msg_2, value_1;
                            const result_3 = _arg_3;
                            return singleton_1.Combine((result_3.tag === 0) ? ((admittanceUsersState[1]((value_2 = (new AdmittanceUserDTOGui(updatedAdmittanceUser.Data, new SaveStatus(2))), (table_3) => add(principalId_1, value_2, table_3))), singleton_1.Zero())) : ((msg_2 = result_3.fields[0], (admittanceUsersState[1]((value_1 = (new AdmittanceUserDTOGui(admittanceUser.Data, new SaveStatus(3, msg_2))), (table_2) => add(principalId_1, value_1, table_2))), (reduxDispatch(error_1(msg_2)), singleton_1.Zero())))), singleton_1.Delay(() => {
                                startImmediate(delayAsync(4000, () => {
                                    admittanceUsersState[1]((admittanceUsers) => add(principalId_1, new AdmittanceUserDTOGui(FSharpMap__get_Item(admittanceUsers, principalId_1).Data, new SaveStatus(0)), admittanceUsers));
                                }));
                                return singleton_1.Zero();
                            }));
                        })))))) : ((logei("[saveMfaMethod] Can\u0027t find admittance user."), singleton_1.Return()))));
                    }])), new ValueProp(0, tupledArg[0], tupledArg[1])), Id, OptionValues, inputRecord_4.Classes, inputRecord_4.LabelText, Disabled, inputRecord_4.HTMLProps))))))];
                    mfaSelectHtml = react.createElement("div", {
                        onClick: (e_1) => {
                            e_1.stopPropagation();
                        },
                    }, ...children_6);
                    let checkMarkHtml;
                    const children_8 = [renderAnimationCheckmark(dto_1.SaveState)];
                    checkMarkHtml = react.createElement("div", {
                        className: "admittance-user__container",
                    }, ...children_8);
                    let ipWhiteListHtml;
                    const props_15 = [new HTMLAttr(65, stackClasses(ofArray(["d-flex", "justify-content-between"])))];
                    const children_14 = toList(delay(() => {
                        let children_10;
                        return append(singleton_2((children_10 = [truncateWithEllipsis(15, defaultArg(dto_1.Data.FenixUser.IpWhiteList, ""))], react.createElement("div", {
                            onClick: (e_3) => {
                                e_3.stopPropagation();
                            },
                        }, ...children_10))), delay(() => {
                            let children_12;
                            return props.GlobalDependencies.IsAdminUser ? singleton_2((children_12 = [getMaterialIconBySize("edit", new Size(2))], react.createElement("div", {
                                className: "admittance-user__edit",
                                id: "admittance-user__edit-ip",
                                onClick: (e_4) => {
                                    e_4.stopPropagation();
                                    ipWhiteListModalState[1](dto_1);
                                },
                            }, ...children_12))) : empty_2();
                        }));
                    }));
                    ipWhiteListHtml = react.createElement("div", keyValueList(props_15, 1), ...children_14);
                    return [toList(delay(() => {
                        let currentRowId, materialIconStr, matchValue_4, props_2, children_1;
                        return append(singleton_2(Elements_renderCell((currentRowId = toString_1(dto_1.Data.AdmittanceUser.PrincipalId), (materialIconStr = ((matchValue_4 = equals(activeRowIdState[0], currentRowId), matchValue_4 ? "expand_less" : "expand_more")), (props_2 = [new HTMLAttr(65, stackClasses(ofArray(["d-flex", "justify-content-end", "pointer"])))], (children_1 = [getMaterialIcon(materialIconStr)], react.createElement("div", keyValueList(props_2, 1), ...children_1))))))), delay(() => append(singleton_2(Elements_renderCell(toString_1(dto_1.Data.AdmittanceUser.PrincipalId))), delay(() => append(singleton_2(Elements_renderCell(dto_1.Data.AdmittanceUser.Name)), delay(() => append(singleton_2(Elements_renderCell(dto_1.Data.AdmittanceUser.LoginName)), delay(() => append(singleton_2(Elements_renderCell(dto_1.Data.AdmittanceUser.AccountType)), delay(() => append(singleton_2(Elements_renderCell(mfaSelectHtml)), delay(() => append(singleton_2(Elements_renderCell(ipWhiteListHtml)), delay(() => append(singleton_2(Elements_renderCell(defaultArg(map_1((date) => DateTimeExtensions_toDateHHmm(locale.ILocale, date), parseDateTime(defaultArg(dto_1.Data.AdmittanceUser.LastLogin, ""))), defaultArg(dto_1.Data.AdmittanceUser.LastLogin, "")))), delay(() => append(props.GlobalDependencies.IsAdminUser ? singleton_2(Elements_renderCell(impersonateHtml)) : empty_2(), delay(() => singleton_2(Elements_renderCell(checkMarkHtml))))))))))))))))))));
                    })), toString_1(dto_1.Data.AdmittanceUser.PrincipalId)];
                }, sortByDescending((dto_3) => dto_3.Data.AdmittanceUser.AccountType, sortBy((dto_2) => dto_2.Data.AdmittanceUser.Name.toLocaleLowerCase(), users, {
                    Compare: comparePrimitives,
                }), {
                    Compare: comparePrimitives,
                })), (principalIdStr) => map_1((admittanceUserDTOGui) => renderExpandAreaFromDTO(new ExpandAreaProps(props.GlobalDependencies.ClientNr, admittanceUserDTOGui.Data.AdmittanceUser.PrincipalId, admittanceUserDTOGui)), bind((principalId_3) => tryFind(principalId_3, admittanceUsersState[0]), parseInt64(principalIdStr))), activeRowIdState));
            }
            default: {
                return react.createElement(react.Fragment, {});
            }
        }
    };
    const users_1 = map((tuple) => tuple[1], toList_1(admittanceUsersState[0]));
    const sveaUsers = filter(isSveaUser, users_1);
    let tabs;
    let uppdragsgivareTab;
    const contentHtml = renderTable(filter((arg_13) => (!isSveaUser(arg_13)), users_1));
    uppdragsgivareTab = (new Tab(void 0, "uppdragsgivare-tab", "Uppdragsgivare", react.createElement("div", {
        className: "admittance-user__tab-container",
    }, contentHtml)));
    tabs = (props.GlobalDependencies.IsAdminUser ? [uppdragsgivareTab, (contentHtml_1 = renderTable(sveaUsers), new Tab(void 0, "svea-tab", "Svea", react.createElement("div", {
        className: "admittance-user__tab-container",
    }, contentHtml_1)))] : [uppdragsgivareTab]);
    let ipWhiteListModalHtml;
    const matchValue_8 = ipWhiteListModalState[0];
    if (matchValue_8 != null) {
        const dto_6 = matchValue_8;
        ipWhiteListModalHtml = renderIpWhiteListModal(new IpWhiteListModalProps(defaultArg(dto_6.Data.FenixUser.IpWhiteList, ""), (principalId_2 = dto_6.Data.AdmittanceUser.PrincipalId, (ipWhiteList) => {
            let matchValue_2, admittanceUser_1, value_3;
            startImmediate((matchValue_2 = tryFind(principalId_2, admittanceUsersState[0]), (matchValue_2 != null) ? ((admittanceUser_1 = matchValue_2, (admittanceUsersState[1]((value_3 = (new AdmittanceUserDTOGui(admittanceUser_1.Data, new SaveStatus(1))), (table_5) => add(principalId_2, value_3, table_5))), singleton_1.Delay(() => singleton_1.Bind(saveIpWhiteList_1(principalId_2, ipWhiteList), (_arg_4) => {
                let value_5, msg_3, value_4;
                const result_4 = _arg_4;
                return singleton_1.Combine((result_4.tag === 0) ? ((admittanceUsersState[1]((value_5 = (new AdmittanceUserDTOGui(admittanceUser_1.Data, new SaveStatus(2))), (table_7) => add(principalId_2, value_5, table_7))), (loadAdmittanceUsers(), singleton_1.Zero()))) : ((msg_3 = result_4.fields[0], (admittanceUsersState[1]((value_4 = (new AdmittanceUserDTOGui(admittanceUser_1.Data, new SaveStatus(3, msg_3))), (table_6) => add(principalId_2, value_4, table_6))), (reduxDispatch(error_1(msg_3)), singleton_1.Zero())))), singleton_1.Delay(() => {
                    startImmediate(delayAsync(4000, () => {
                        admittanceUsersState[1]((admittanceUsers_1) => add(principalId_2, new AdmittanceUserDTOGui(FSharpMap__get_Item(admittanceUsers_1, principalId_2).Data, new SaveStatus(0)), admittanceUsers_1));
                    }));
                    return singleton_1.Zero();
                }));
            }))))) : ((logei("[saveIpWhiteList] Can\u0027t find admittance user."), singleton_1.Return()))));
        }), () => {
            ipWhiteListModalState[1](void 0);
        }));
    }
    else {
        ipWhiteListModalHtml = react.createElement(react.Fragment, {});
    }
    const children_33 = toList(delay(() => {
        let children_31;
        return append(singleton_2((children_31 = [getTranslationFrom(translationsLoadState, "Home.AdmittanceUser")], react.createElement("h2", {}, ...children_31))), delay(() => {
            let inputRecord_5;
            return append(singleton_2(renderTabContainer((inputRecord_5 = TabContainerProps_get_Default(), new TabContainerProps(tabs)))), delay(() => (props.GlobalDependencies.IsAdminUser ? append(singleton_2(impersonateModalHtml), delay(() => singleton_2(ipWhiteListModalHtml))) : empty_2())));
        }));
    }));
    return react.createElement("div", {
        className: "admittance-users",
    }, ...children_33);
}, "AdmittanceUsers", uncurry(2, void 0), void 0, "renderAdmittanceUsers", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\AdmittanceUsers\\View.fs", 823);

